import React from 'react';
export function Footer() {
  return <footer className="bg-brand-black py-8 border-t border-white/5 text-center px-4" data-id="element-48">
      <div className="mx-auto max-w-3xl" data-id="element-49">
        <div className="mb-4 h-px w-full bg-gradient-to-r from-transparent via-brand-green/50 to-transparent" data-id="element-50"></div>
        <p className="text-gray-500 text-sm mb-4" data-id="element-51">
          © {new Date().getFullYear()} Cierre 2.0 · Todos los derechos
          reservados
        </p>
        <div className="flex justify-center gap-4 text-xs text-gray-600" data-id="element-52">
          <a href="#" className="hover:text-brand-green transition-colors" data-id="element-53">
            Política de privacidad
          </a>
          <span data-id="element-54">|</span>
          <a href="#" className="hover:text-brand-green transition-colors" data-id="element-55">
            Términos y condiciones
          </a>
          <span data-id="element-56">|</span>
          <a href="#" className="hover:text-brand-green transition-colors" data-id="element-57">
            Contacto
          </a>
        </div>
        <p className="text-[10px] text-gray-700 mt-6 max-w-2xl mx-auto" data-id="element-58">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}